import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OmnichannelPageNotFoundComponent } from './features/omnichannel-pagenotfound/omnichannel-pagenotfound.component';
import { environment } from '../environments/environment';

const rootHomeRoutes: Routes = environment.envName === 'prod.au'
  ? [
      {
        path: '',
        loadChildren: () => import('./features/omnichannel-blankhome/omnichannel-blankhome.module').then(m => m.OmnichannelBlankHomeModule)
      }
    ]
  : [
      {
        path: '',
        loadChildren: () => import('./features/omnichannel-webflow/omnichannel-webflow.module').then(m => m.OmnichannelWebflowModule)
      }
    ];

const routes: Routes = [
  {
    path: "extend",
    loadChildren: () => import("./features/omnichannel-extend/omnichannel-extend.module").then(m => m.OmnichannelExtendModule)
  },
  {
    path: "initial",
    loadChildren: () => import("./features/omnichannel-initial/omnichannel-initial.module").then(m => m.OmnichannelInitialModule)
  },
  {
    path: "outofhours",
    loadChildren: () => import("./features/omnichannel-outofhours/omnichannel-outofhours.module").then(m => m.OmnichannelOutofhoursModule)
  }, 
  {
    path: "postpay",
    loadChildren: () => import("./features/omnichannel-postpay/omnichannel-postpay.module").then(m => m.OmnichannelPostpayModule)
  },
  {
    path: "payments",
    loadChildren: () => import("./features/omnichannel-payments/omnichannel-payments.module").then(m => m.OmnichannelPaymentsModule)
  },
  {
    path: "404",
    loadChildren: () => import("./features/omnichannel-pagenotfound/omnichannel-pagenotfound.module").then(m => m.OmnichannelPageNotFoundModule)
  },
  ...rootHomeRoutes,
  { path: '**', component:OmnichannelPageNotFoundComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
